import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Check if this is a sort form with a select element
    const sortSelect = this.element.querySelector('select[name="sort_by"]')
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        this.submit()
      })
    }
  }
  
  submit() {
    this.element.requestSubmit()
  }
} 
